import {useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css'
import {useState} from 'react';
import { BrowserRouter as Router, Route, Routes,useNavigate  } from 'react-router-dom';
import LandingPage from './Page/LandingPage/LandingPage';
import ActionPage from './Page/ActionPage/ActionPage';
import AccessPage from './Page/AccessPage/AccessPage';
import  LoginPage  from './Page/LoginPage/LoginPage';
import ManagementSystem from './Page/ManagementSystem/ManagementSystem';
import useToken from './Page/LoginPage/useToken';
import Routing from './Routing';
import SignUpPage from './Page/SignUpPage/SignUpPage';
import MainHeader from './Components/MainHeader/MainHeader';
import LandingLoginPage from './Page/DealerEmployeeLandingPage/LandingLoginPage';
import ForgetPassword from './Page/ForgetPasswordPage/ForgetPassword';
import DealerSignupPage from './Page/SignUpPage/DealerSignupPage';
import ADFSLoginPage from './Page/ADFSLoginPage';
import { Helmet } from 'react-helmet';
import FrameBuster from './FrameBuster';

function App() {


   
  return (
    // <Helmet>
      // <meta http-equiv="X-Frame-Options" content="DENY" />
      // <meta http-equiv="Content-Security-Policy" content="frame-ancestors 'none'" />
      // <meta http-equiv="Feature-Policy" content="frame-ancestors 'none'" />
      <Router>
        <FrameBuster/>
        <Routing />
      </Router>
  );
}
    

export default App;
